import type { PropsWithChildren } from 'react';
import React from 'react';
import type { OptionsProps } from './options/Options';
import Options from './options/Options';
import { cn } from '@/lib/utils';

export enum MenuType {
  Search = 'search',
  Leveled = 'leveled',
}

export interface MenuProps<V> extends OptionsProps<V> {
  type?: MenuType;
  className?: string;
  style?: Record<string, unknown>;
  shouldRender?: boolean;
  isLoading?: boolean;
  showOptions?: boolean;
}

export const Menu = <V,>({
  children,
  className,
  style,
  shouldRender = true,
  showOptions = true,
  type,
  ...optionsProps
}: PropsWithChildren<MenuProps<V>>) => {
  if (!shouldRender) {
    return null;
  }

  return (
    <div
      className={cn([
        'flex relative flex-col max-w-[284px] max-h-[172px] border border-solid border-venn-grey bg-venn-white',
        type === MenuType.Search && 'w-full min-w-[208px] max-w-[324px] border-0',
        type === MenuType.Leveled && 'max-w-[224px]',
        className,
      ])}
      style={style}
    >
      {children}
      {showOptions && <Options {...optionsProps} />}
    </div>
  );
};

export default Menu;
